import { render, staticRenderFns } from "./shipment-open-report-payments-display.vue?vue&type=template&id=1f526b37&scoped=true"
import script from "./shipment-open-report-payments-display.vue?vue&type=script&lang=js"
export * from "./shipment-open-report-payments-display.vue?vue&type=script&lang=js"
import style0 from "./shipment-open-report-payments-display.vue?vue&type=style&index=0&id=1f526b37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f526b37",
  null
  
)

export default component.exports